import { ProjectComplet } from "@/interfaces/projects";


function state(): ProjectComplet {
    return {
        project: {
            id_proyecto: 0,
            nombre: '',
            descripcion: '',
            id_cliente: 0,
        },
        client: {
            activo: false,
            apiKey: '',
            codigo: 0,
            id_cliente: 0,
            int_dato1: '',
            int_dato2: 0,
            int_dato3: '',
            int_dato4: '',
            nombre: '',
            params: [],
            str_dato1: '',
            str_dato2: '',
            str_dato3: '',
            str_dato4: '',
        },
        documents: [],
        samples: 0,
        total: 0,
        review: 0,
        reviewError: 0,
        currentDate: '',
        newDocsToday: 0,
        prioritario: 0,
        reviewPending: 0,
        reviewedToday: 0,
        isSearching: false,
    }

}

export default state;